export default __webpack_public_path__ + "static/logicloud-51453f4d7610f486646350f5c1a34bb9.png";